module.exports = __webpack_public_path__ + "static/media/appleSlices.59292924.png";